/* ══════════════════════════════════════════════════════════════════════════
   PAID IN FULL — LANDING PAGE BEHAVIOUR
   Loaded by sections/igk-paid-in-full-lp.liquid, and by the standalone preview.

   ONE FILE, TWO HOSTS. It detects its origin and adapts:
     · on igkhair.com  — real AJAX Cart API, hands off to the theme's own
                         Horizon cart drawer
     · anywhere else   — cart staged locally, handed to the shop as a cart
                         permalink at checkout
   Keeping it one file is deliberate: the standalone preview stays a truthful
   proof of what the Liquid build does, instead of drifting into a mock.

   It also prefers server-rendered product JSON (#pif-product-data) over a
   fetch, so on the theme there is no first-paint flash of fallback pricing.
   ══════════════════════════════════════════════════════════════════════════ */
(function () {

  /* ── STAR BAR ─────────────────────────────────────
     The markup printed five solid stars regardless of the score. This clips
     the filled row to the real average, so a 4.6 looks like a 4.6. Called
     once with the fallback and again when Yotpo answers. */
  function paintStars(score) {
    var pct = Math.max(0, Math.min(100, (Number(score) / 5) * 100));
    ['hero-stars', 'proof-stars'].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      var fill = el.querySelector('i');
      /* Clip from the right rather than setting a width. A width plus
         overflow:hidden also cut the top of the star glyph, which is what
         left the partial star missing its points. */
      if (fill) fill.style.clipPath = 'inset(-30% ' + (100 - pct).toFixed(1) + '% -30% 0)';
      var host = el.closest('.hero-rating, .proof-rating') || el.parentNode;
      host.setAttribute('role', 'img');
      host.setAttribute('aria-label', Number(score).toFixed(1) + ' out of 5 stars');
    });
  }
  paintStars((document.getElementById('hero-rating') || {}).textContent || 4.6);

  /* ── RATING DISTRIBUTION ──────────────────────────
     Yotpo returns bottomline.star_distribution in the same call the rating
     comes from, so the spread costs no extra request. Bars are percentages of
     the total, which is what makes a 4.6 legible: the shape of the
     distribution is the argument, not the average. */
  function paintDistribution(dist, total) {
    if (!dist || !total) return;
    for (var s = 1; s <= 5; s++) {
      var n = Number(dist[s] || dist[String(s)] || 0);
      var fill  = document.getElementById('dist-fill-' + s);
      var count = document.getElementById('dist-count-' + s);
      if (fill)  fill.style.width = ((n / total) * 100).toFixed(1) + '%';
      if (count) count.textContent = n.toLocaleString();
    }
    var wrap = document.getElementById('rating-dist');
    if (wrap) wrap.setAttribute('aria-label',
      'Rating breakdown across ' + total.toLocaleString() + ' reviews');
  }

  /* ══════════════════════════════════════════════════════════════════════
     SHOPIFY CONFIG — resolved from the live listing on 2026-08-27.
     Everything below is public storefront data (product JSON + Recharge
     selling plans); no tokens or admin credentials are involved.

       product   8208481648684  paid-in-full-high-gloss-intense-repair-treatment
       Retail             45360108240940   $38.00   1 unit
       Buy 2, Get 1 Free  45360108273708   $76.00   3 units

     Buy 3, Get 2 Free (45360108306476) is deliberately NOT offered here. IGK
     is sunsetting 5-packs; the variant may still exist in Shopify, but this
     page does not surface it. The Liquid leaves its tier_key blank so the card
     is skipped, and the 5-carton stack image is off the carousel allowlist.

     Subscribe & Save is Recharge (app 294517), 15% off, three plans:
       every 30 days  2130149420      every 60 days  2130182188
       every 90 days  2130214956
     All three plans are allocated to ALL three variants.

     Ids are hardcoded so the page still transacts if the JSON fetch fails,
     and re-verified against the live JSON on load — see reconcile().
     ══════════════════════════════════════════════════════════════════════ */
  var SHOPIFY = {
    origin:    'https://www.igkhair.com',
    handle:    'paid-in-full-high-gloss-intense-repair-treatment',
    productId: 8208481648684,
    variants:     { '1pack': 45360108240940, '2pack': 45360108273708 },
    sellingPlans: { 30: 2130149420, 60: 2130182188, 90: 2130214956 },
    unitPrice: 3800  /* cents; refreshed from live JSON */
  };

  /* Same-origin means this page is being served from the shop itself (a Shopify
     template or page), where the AJAX Cart API is reachable. Anywhere else the
     browser blocks it — Shopify sends no Access-Control-Allow-Origin on
     /cart/*.js — so we stage the cart locally and hand off via a cart permalink. */
  var SAME_ORIGIN = /(^|\.)igkhair\.com$/i.test(window.location.hostname);

  var money = function (cents) {
    return '$' + (cents / 100).toFixed(2);
  };

  /* ══════════════════════════════════════════════════════════════════════
     LIVE PRODUCT DATA
     Uses the .js endpoint (not .json) because only .js carries
     selling_plan_groups and per-variant selling_plan_allocations.
     ══════════════════════════════════════════════════════════════════════ */
  var PRODUCT = null;

  function loadProduct() {
    /* The Liquid section embeds the product as JSON so prices, plans and
       images are correct on first paint with no round trip. `product | json`
       emits the same shape as /products/<handle>.js, so the rest of this file
       does not care which source it came from. Standalone (no section) falls
       through to the fetch. */
    var embedded = document.getElementById('pif-product-data');
    if (embedded) {
      try {
        var parsed = JSON.parse(embedded.textContent);
        if (parsed && parsed.variants) {
          PRODUCT = parsed;
          reconcile(parsed);
          return Promise.resolve(parsed);
        }
      } catch (e) {
        console.warn('[IGK LP] Embedded product JSON unreadable — falling back to fetch.', e);
      }
    }

    return fetch(SHOPIFY.origin + '/products/' + SHOPIFY.handle + '.js', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (data) { PRODUCT = data; reconcile(data); return data; })
      .catch(function (e) {
        console.warn('[IGK LP] Product fetch failed — using hardcoded fallbacks.', e);
        return null;
      });
  }

  /* Re-point the hardcoded ids at whatever the shop actually returns, so a
     variant or Recharge plan rebuild degrades into a stale-price warning
     rather than an add-to-cart that 422s. */
  function reconcile(data) {
    if (!data || !data.variants) return;

    /* Keyed on id. This used to look variants up by title, which broke on
       2026-10-20 when merchandising renamed them. Ids survive renames. */
    var byId = {};
    data.variants.forEach(function (v) { byId[v.id] = v; });

    Object.keys(SHOPIFY.variants).forEach(function (key) {
      if (!byId[SHOPIFY.variants[key]]) {
        console.warn('[IGK LP] Variant ' + SHOPIFY.variants[key] + ' (' + key +
                     ') is not on the product any more. Its card will price ' +
                     'from the markup until the id here is updated.');
      }
    });

    var base = byId[SHOPIFY.variants['1pack']];
    if (base) SHOPIFY.unitPrice = base.price;

    /* Refresh selling plan ids from the live groups, keyed off the interval
       stated in each group's "Order Frequency and Unit" option (e.g. "30-day"). */
    (data.selling_plan_groups || []).forEach(function (g) {
      var interval = null;
      (g.options || []).forEach(function (o) {
        var m = /(\d+)\s*-?\s*day/i.exec((o.values || []).join(' '));
        if (m) interval = m[1];
      });
      var plan = (g.selling_plans || [])[0];
      if (interval && plan && SHOPIFY.sellingPlans[interval] !== plan.id) {
        console.warn('[IGK LP] Selling plan for ' + interval + '-day changed -> ' + plan.id);
        SHOPIFY.sellingPlans[interval] = plan.id;
        var input = document.querySelector('.freq-opt input[data-interval="' + interval + '"]');
        if (input) input.value = plan.id;
      }
    });

    paintPrices(data);
  }

  /* Purchase mode applies across all three packs. */
  var MODE = 'onetime';   /* 'onetime' | 'subscribe' */

  function currentPlanId() {
    var f = document.querySelector('.freq-opt input:checked');
    return Number(f ? f.value : SHOPIFY.sellingPlans[30]);
  }

  function currentInterval() {
    var f = document.querySelector('.freq-opt input:checked');
    return f ? f.dataset.interval : '30';
  }

  /* Price for a variant under the current mode. Subscription pricing comes from
     the selling plan allocation, never from the variant price — the 15% is
     applied by Recharge, so deriving it locally would drift the moment the
     plan changes. */
  function priceFor(variant) {
    if (MODE === 'subscribe') {
      var planId = currentPlanId();
      var alloc = (variant.selling_plan_allocations || []).filter(function (a) {
        return a.selling_plan_id === planId;
      })[0];
      if (alloc) return alloc.price;
    }
    return variant.price;
  }

  /* Write live prices into the tier cards. The "Was" figures are unit price x
     units — the bundle variants carry no compare_at_price, so presenting a
     Shopify compare-at here would be inventing one. */
  function paintPrices(data) {
    if (!data) return;
    var byId = {};
    (data.variants || []).forEach(function (v) { byId[v.id] = v; });

    document.querySelectorAll('.tier-input').forEach(function (input) {
      var v = byId[Number(input.dataset.variant)];
      if (!v) return;

      var key   = input.dataset.tier;
      var units = Number(input.dataset.units || 1);
      var cents = priceFor(v);
      var oneTime = v.price;

      input.dataset.price = money(cents);

      var elPrice = document.getElementById('price-' + key);
      if (elPrice) elPrice.textContent = money(cents);

      var elWas  = document.getElementById('was-' + key);
      var elSave = document.getElementById('save-' + key);

      /* Reference price: on a multipack it is what the units would cost bought
         singly; on the 1 pack there is nothing to strike through EXCEPT the
         one-time price once subscribing. */
      var regular = (units > 1) ? SHOPIFY.unitPrice * units : oneTime;
      var pct = regular > cents ? Math.round((1 - cents / regular) * 100) : 0;

      if (elWas) {
        if (regular > cents) {
          elWas.textContent = money(regular);
          elWas.style.display = '';
        } else {
          elWas.style.display = 'none';
        }
      }
      if (elSave) elSave.textContent = pct ? 'Save ' + pct + '%' : '';

      /* Per-treatment price. The multipacks are the whole reason this ladder
         exists and the page was leaving the reader to divide 114 by 5. */
      var elUnit = document.getElementById('unit-' + key);
      if (elUnit) elUnit.textContent = money(Math.round(cents / units)) + ' each';

      /* Note under the headline price. */
      if (MODE === 'subscribe') {
        input.dataset.note = 'Every ' + currentInterval() + ' days &middot; cancel anytime';
      } else if (units > 1) {
        input.dataset.note = (pct ? 'Save ' + pct + '% &middot; ' : '') + units + ' treatments';
      } else {
        var alloc = (v.selling_plan_allocations || [])[0];
        input.dataset.note = alloc
          ? money(alloc.price) + ' with Subscribe &amp; Save'
          : '';
      }
    });

    paintBarFloor(data);
    syncPack();
    }

    /* ══════════════════════════════════════════════════════════════════════
     PACK SELECTOR + MODE — mirror the choice into the headline block and CTA.
     ══════════════════════════════════════════════════════════════════════ */
  function selectedTier() {
    return document.querySelector('.tier-input:checked');
  }

  function syncPack() {
    var sel = selectedTier();
    if (!sel) return;

    var elNow  = document.getElementById('price-hero');
    var elWas  = document.getElementById('compare-hero');
    var elNote = document.getElementById('off-hero');
    var isSub  = MODE === 'subscribe';

    if (elNow)  elNow.textContent = sel.dataset.price;
    if (elNote) elNote.innerHTML  = sel.dataset.note || '';

    /* Headline strikethrough shows the one-time price of the SAME pack while
       subscribed, so the 15% is legible against a like-for-like number. */
    if (elWas) {
      var tierWas = document.getElementById('was-' + sel.dataset.tier);
      if (isSub && tierWas && tierWas.style.display !== 'none') {
        elWas.textContent = tierWas.textContent;
        elWas.style.display = 'inline';
      } else {
        elWas.style.display = 'none';
      }
    }

    var atcPrice = document.getElementById('atc-price');
    if (atcPrice) atcPrice.textContent = sel.dataset.price;

    var atc = document.getElementById('atc-btn');
    if (atc) atc.firstChild.nodeValue = isSub ? 'Subscribe \u00b7 ' : 'Add To Cart \u00b7 ';


    showTierImage(sel.dataset.tier);
  }

  /* The sticky bar quotes a floor, not the current selection: it says "From".
     Lowest price the page can actually transact is the smallest variant price
     against the smallest selling-plan allocation, which today is the 1-pack on
     subscription. Derived, never hardcoded, so a price or plan change carries
     into it. */
  function paintBarFloor(data) {
    var el = document.getElementById('buy-bar-price');
    if (!el || !data || !data.variants) return;
    var lowest = null;
    data.variants.forEach(function (v) {
      if (!v.available) return;
      var candidates = [v.price].concat(
        (v.selling_plan_allocations || []).map(function (a) { return a.price; })
      );
      candidates.forEach(function (c) {
        if (typeof c === 'number' && (lowest === null || c < lowest)) lowest = c;
      });
    });
    if (lowest !== null) el.textContent = money(lowest);
  }

  function setMode(mode) {
    MODE = mode;
    document.querySelectorAll('.buy-opt').forEach(function (b) {
      b.setAttribute('aria-selected', String(b.dataset.mode === mode));
    });
    var freq  = document.getElementById('freq-wrap');
    var perks = document.getElementById('sub-perks');
    if (freq)  freq.hidden  = mode !== 'subscribe';
    if (perks) perks.hidden = mode !== 'subscribe';
    if (PRODUCT) paintPrices(PRODUCT); else syncPack();
  }

  document.querySelectorAll('.buy-opt').forEach(function (b) {
    b.addEventListener('click', function () { setMode(b.dataset.mode); });
    /* Left/right arrows move between tabs, per the tablist pattern. */
    b.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      e.preventDefault();
      var opts = [].slice.call(document.querySelectorAll('.buy-opt'));
      var next = opts[(opts.indexOf(b) + (e.key === 'ArrowRight' ? 1 : -1) + opts.length) % opts.length];
      next.focus();
      setMode(next.dataset.mode);
    });
  });

  document.querySelectorAll('.tier-input').forEach(function (i) {
    i.addEventListener('change', syncPack);
  });
  document.querySelectorAll('.freq-opt input').forEach(function (i) {
    i.addEventListener('change', function () {
      if (PRODUCT) paintPrices(PRODUCT); else syncPack();
    });
  });

  /* ══════════════════════════════════════════════════════════════════════
     PRODUCT IMAGE CAROUSEL — VETTED ALLOWLIST, FAIL CLOSED
     The PDP's own image set cannot be rendered wholesale. Two of its
     infographics carry claims this page is barred from making:
       · Infographic_ClinicallyProven  — "6X STRONGER HAIR", "8X SOFTER +
         SMOOTHER HAIR" in headline type. No substantiation on file.
       · Infographic_StrongerTogether  — "SALON-LEVEL REPAIR", plus a
         cross-sell for a different SKU. Salon equivalence is barred outright
         (Mallory Capasso, VP Legal, 2026-07-15).
     So images are matched against a reviewed allowlist and ANYTHING
     UNRECOGNISED IS SKIPPED. A new asset added to the PDP will not appear
     here until a human reviews it and adds its token below. That is
     deliberate: silently inheriting an unvetted claim asset is the failure
     mode worth engineering against.

     Note: the carton front is legible in the product shots and its small
     print still reads "6X STRONGER HAIR" / "8X SOFTER AND SMOOTHER". That is
     the packaging itself and is the same known, accepted risk already logged
     against the hero image. Flag to legal with the hero, not separately.
     ══════════════════════════════════════════════════════════════════════ */
  var IMAGE_ALLOWLIST = [
    'PaidInFull_Product_',                     /* single carton, 3/4 view   */
    'PaidInFull_Infographic_BenefitClaims',    /* the 3 permitted claims    */
    'PaidInFull_Infographic_KeyIngredient',    /* Lift+Seal, vegan proteins */
    'PaidInFull_Box_Contents',                 /* kit flatlay + glove       */
    'PaidInFull_Infographic_HowToUse',         /* 10-minute method          */
    'FreeFrom_BenefitsTicker',                 /* vegan / sulfate-free etc  */
    'Untitled_design_12'                       /* 3-carton stack -> 2pack   */
  ];

  /* Tier -> the carousel image that should lead when that tier is chosen.
     Matches the pack she is actually buying to the pack she is looking at. */
  var TIER_IMAGE = {
    '1pack': 'PaidInFull_Product_',
    '2pack': 'Untitled_design_12'
  };

  var carouselImages = [];

  function vetted(src) {
    return IMAGE_ALLOWLIST.some(function (token) { return src.indexOf(token) !== -1; });
  }

  function showTierImage(tierKey) {
    var token = TIER_IMAGE[tierKey];
    if (!token || !carouselImages.length) return;
    for (var i = 0; i < carouselImages.length; i++) {
      if (carouselImages[i].indexOf(token) !== -1) { setMainImage(i); return; }
    }
  }

  function setMainImage(index) {
    var mainImg = document.getElementById('pdp-main-img');
    var thumbs  = document.getElementById('pdp-thumbs');
    if (!mainImg || !carouselImages[index]) return;
    mainImg.src = carouselImages[index];
    if (!thumbs) return;
    thumbs.querySelectorAll('.pdp-thumb').forEach(function (t, i) {
      t.classList.toggle('active', i === index);
    });
  }

  function buildCarousel(data) {
    var mainImg  = document.getElementById('pdp-main-img');
    var thumbsEl = document.getElementById('pdp-thumbs');
    var carousel = document.getElementById('pdp-carousel');
    if (!mainImg || !thumbsEl) return;

    /* On the theme, Liquid has already rendered the carousel through the same
       allowlist. Adopt that markup rather than tearing it down and rebuilding
       it from the embedded JSON — re-rendering would swap correctly-sized
       images for full-size ones and throw away the server's first paint. */
    var rendered = thumbsEl.querySelectorAll('.pdp-thumb');
    if (rendered.length) {
      carouselImages = [].map.call(rendered, function (t) {
        return t.dataset.full || t.querySelector('img').src;
      });
      [].forEach.call(rendered, function (t, i) {
        t.addEventListener('click', function () { setMainImage(i); });
      });
      carousel.hidden = false;
      var pre = selectedTier();
      if (pre) showTierImage(pre.dataset.tier);
      return;
    }

    if (!data) return;

    var all = (data.images || []);
    var kept = all.filter(vetted);
    var dropped = all.length - kept.length;
    if (dropped > 0) {
      console.info('[IGK LP] Carousel: ' + dropped + ' of ' + all.length +
                   ' PDP images withheld (not on the reviewed allowlist).');
    }
    if (!kept.length) return; /* stays hidden — no stand-in imagery by design */

    carouselImages = kept;
    thumbsEl.innerHTML = '';
    kept.forEach(function (src, i) {
      var wrap = document.createElement('div');
      wrap.className = 'pdp-thumb' + (i === 0 ? ' active' : '');
      var el = document.createElement('img');
      el.src = src;
      el.alt = 'IGK Paid In Full, view ' + (i + 1);
      el.loading = 'lazy';
      wrap.appendChild(el);
      wrap.addEventListener('click', function () { setMainImage(i); });
      thumbsEl.appendChild(wrap);
    });

    setMainImage(0);
    carousel.hidden = false;
    var sel = selectedTier();
    if (sel) showTierImage(sel.value);
  }

  /* ══════════════════════════════════════════════════════════════════════
     CART ENGINE

     Two backends behind one interface, chosen by origin:

     · SAME ORIGIN (this page served from igkhair.com as a Shopify template)
       Real AJAX Cart API — /cart/add.js, /cart.js, /cart/change.js. The
       session cart is the shop's own, so the header count, shipping
       thresholds and checkout are all genuinely live. After a successful add
       we try to hand off to the theme's real Horizon cart drawer by clicking
       its trigger; our drawer is only used if that trigger is absent.

     · CROSS ORIGIN (preview, staging, anywhere else)
       Shopify serves no CORS headers on /cart/*.js, so the real cart is
       simply unreachable from another origin — verified, not assumed. Lines
       are staged in sessionStorage and handed to the shop as a cart
       permalink at checkout, which builds the real cart server-side and
       carries the selling_plan through. Confirmed working against the live
       store, including the Recharge plan.

     The permalink format takes ONE global selling_plan, so it cannot express
     "line 1 one-time, line 2 subscription". Staging therefore keeps a
     subscription on its own: adding a subscription clears one-time lines and
     vice versa. Same-origin mode has no such restriction.
     ══════════════════════════════════════════════════════════════════════ */
  var STORAGE_KEY = 'igk_lp_cart_v1';

  var LocalCart = {
    lines: [],

    load: function () {
      try {
        var raw = sessionStorage.getItem(STORAGE_KEY);
        this.lines = raw ? JSON.parse(raw) : [];
      } catch (e) { this.lines = []; }
      return Promise.resolve(this.state());
    },

    save: function () {
      try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(this.lines)); }
      catch (e) { /* private mode — cart stays in memory for this page view */ }
    },

    add: function (item) {
      var isSub = !!item.selling_plan;
      var hasSub = this.lines.some(function (l) { return !!l.selling_plan; });
      /* Permalink can carry only one selling_plan — keep subscriptions alone. */
      if (isSub || hasSub) this.lines = [];

      var existing = this.lines.filter(function (l) {
        return l.id === item.id && l.selling_plan === item.selling_plan;
      })[0];

      if (existing) existing.quantity += item.quantity;
      else this.lines.push(item);

      this.save();
      return Promise.resolve(this.state());
    },

    change: function (key, quantity) {
      var i = Number(key);
      if (quantity <= 0) this.lines.splice(i, 1);
      else if (this.lines[i]) this.lines[i].quantity = quantity;
      this.save();
      return Promise.resolve(this.state());
    },

    state: function () {
      var items = this.lines.map(function (l, i) {
        return {
          key: String(i),
          id: l.id,
          quantity: l.quantity,
          title: l.title,
          variant_title: l.variant_title,
          selling_plan_name: l.selling_plan_name || null,
          image: l.image,
          line_price: l.price * l.quantity,
          final_line_price: l.price * l.quantity
        };
      });
      return {
        items: items,
        item_count: items.reduce(function (n, i) { return n + i.quantity; }, 0),
        total_price: items.reduce(function (n, i) { return n + i.final_line_price; }, 0)
      };
    },

    checkoutUrl: function (toCartPage) {
      if (!this.lines.length) return null;
      var path = this.lines.map(function (l) { return l.id + ':' + l.quantity; }).join(',');
      var qs = [];
      var sub = this.lines.filter(function (l) { return !!l.selling_plan; })[0];
      if (sub) qs.push('selling_plan=' + sub.selling_plan);
      if (toCartPage) qs.push('storefront=true');
      return SHOPIFY.origin + '/cart/' + path + (qs.length ? '?' + qs.join('&') : '');
    }
  };

  var ShopifyCart = {
    load: function () {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); });
    },
    add: function (item) {
      var payload = { id: item.id, quantity: item.quantity };
      if (item.selling_plan) payload.selling_plan = item.selling_plan;
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [payload] })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (e) {
            throw new Error(e.description || e.message || 'Could not add to cart.');
          });
          return r.json();
        })
        .then(function () { return ShopifyCart.load(); });
    },
    change: function (key, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      }).then(function (r) { return r.json(); });
    },
    checkoutUrl: function (toCartPage) { return toCartPage ? '/cart' : '/checkout'; }
  };

  var Cart = SAME_ORIGIN ? ShopifyCart : LocalCart;

  /* ── DRAWER RENDERING ─────────────────────────── */
  var drawer  = document.getElementById('cart-drawer');
  var overlay = document.getElementById('cart-overlay');
  var lastFocus = null;

  function openDrawer() {
    /* On the shop itself, prefer the theme's own drawer — it is the real one,
       and it stays in sync with the rest of the header.

       ONLY if that trigger is actually on screen. With hide_theme_chrome on,
       the theme header is display:none and its cart trigger goes with it, so
       this handed the click to an element nobody can see and returned: the
       theme drawer did not open, ours never got the chance, and the cart was
       unreachable. Measuring the rect rather than offsetParent on purpose —
       offsetParent is also null for position:fixed, which a sticky header cart
       button legitimately is. */
    if (SAME_ORIGIN) {
      var themeTrigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
      if (themeTrigger && !drawer.contains(themeTrigger)) {
        var tRect = themeTrigger.getBoundingClientRect();
        if (tRect.width > 0 || tRect.height > 0) { themeTrigger.click(); return; }
      }
    }
    lastFocus = document.activeElement;
    drawer.hidden = false;
    overlay.hidden = false;
    /* Force a reflow so the browser registers the un-hidden start state before
       the class flips, which is what makes the transform actually animate.
       Deliberately NOT requestAnimationFrame: rAF is starved in a background
       tab, so a cart added from an inactive tab would leave the drawer
       translated off-screen with no way to bring it back. */
    void drawer.offsetHeight;
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    document.getElementById('cart-btn').setAttribute('aria-expanded', 'true');
    document.getElementById('cart-close').focus();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    document.getElementById('cart-btn').setAttribute('aria-expanded', 'false');
    setTimeout(function () { drawer.hidden = true; overlay.hidden = true; }, 280);
    if (lastFocus) lastFocus.focus();
  }

  function renderCart(state) {
    var body     = document.getElementById('cart-body');
    var empty    = document.getElementById('cart-empty');
    var foot     = document.getElementById('cart-foot');
    var bubble   = document.getElementById('cart-bubble');
    var subtotal = document.getElementById('cart-subtotal');
    var thresh   = document.getElementById('cart-threshold');
    if (!body) return;

    var count = state ? state.item_count : 0;
    bubble.textContent = count;
    bubble.classList.toggle('is-visible', count > 0);
    document.getElementById('cart-btn')
      .setAttribute('aria-label', count ? 'Cart, ' + count + ' items' : 'Cart');

    body.querySelectorAll('.cart-line').forEach(function (n) { n.remove(); });

    if (!count) {
      empty.hidden = false;
      foot.hidden = true;
      return;
    }
    empty.hidden = true;
    foot.hidden = false;

    state.items.forEach(function (item) {
      var line = document.createElement('div');
      line.className = 'cart-line';

      var img = document.createElement('img');
      img.className = 'cart-line-img';
      img.src = item.image || '';
      img.alt = '';
      img.loading = 'lazy';
      line.appendChild(img);

      var info = document.createElement('div');

      var t = document.createElement('div');
      t.className = 'cart-line-title';
      t.textContent = item.product_title || item.title || 'Paid In Full';
      info.appendChild(t);

      if (item.variant_title) {
        var vt = document.createElement('div');
        vt.className = 'cart-line-variant';
        vt.textContent = item.variant_title;
        info.appendChild(vt);
      }

      if (item.selling_plan_name ||
          (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan)) {
        var pn = document.createElement('div');
        pn.className = 'cart-line-plan';
        pn.textContent = item.selling_plan_name ||
          item.selling_plan_allocation.selling_plan.name;
        info.appendChild(pn);
      }

      var foot2 = document.createElement('div');
      foot2.className = 'cart-line-foot';

      var qty = document.createElement('div');
      qty.className = 'cart-qty';
      var minus = document.createElement('button');
      minus.type = 'button';
      minus.textContent = '−';
      minus.setAttribute('aria-label', 'Decrease quantity');
      var num = document.createElement('span');
      num.textContent = item.quantity;
      var plus = document.createElement('button');
      plus.type = 'button';
      plus.textContent = '+';
      plus.setAttribute('aria-label', 'Increase quantity');
      minus.addEventListener('click', function () { updateLine(item.key, item.quantity - 1); });
      plus.addEventListener('click',  function () { updateLine(item.key, item.quantity + 1); });
      qty.appendChild(minus); qty.appendChild(num); qty.appendChild(plus);
      foot2.appendChild(qty);

      var price = document.createElement('div');
      price.className = 'cart-line-price';
      price.textContent = money(item.final_line_price != null
        ? item.final_line_price : item.line_price);
      foot2.appendChild(price);

      info.appendChild(foot2);

      var rm = document.createElement('button');
      rm.type = 'button';
      rm.className = 'cart-line-remove';
      rm.textContent = 'Remove';
      rm.addEventListener('click', function () { updateLine(item.key, 0); });
      info.appendChild(rm);

      line.appendChild(info);
      body.insertBefore(line, empty);
    });

    subtotal.textContent = money(state.total_price);

    /* One live threshold: free U.S. shipping at $50. The $45 mystery-gift
       tier was removed when that promotion ended. */
    var total = state.total_price;
    thresh.hidden = false;
    if (total >= 5000) {
      thresh.textContent = '✓ Free U.S. shipping unlocked';
    } else {
      thresh.textContent = money(5000 - total) + ' more for free U.S. shipping';
    }
  }

  function updateLine(key, quantity) {
    setError('');
    Cart.change(key, quantity)
      .then(renderCart)
      .catch(function (e) { setError(e.message || 'Could not update the cart.'); });
  }

  function setError(msg) {
    var el = document.getElementById('cart-error');
    if (el) el.textContent = msg || '';
  }

  function refreshCart() {
    return Cart.load().then(renderCart).catch(function () { renderCart(null); });
  }

  /* ── ADD TO CART ──────────────────────────────── */
  function addToCart() {
    var sel = selectedTier();
    if (!sel) return;
    setError('');

    var btn = document.getElementById('atc-btn');
    btn.setAttribute('aria-busy', 'true');

    var isSub = MODE === 'subscribe';

    var item = {
      id: Number(sel.dataset.variant),
      quantity: 1,
      selling_plan: isSub ? currentPlanId() : null
    };

    /* The local backend renders from staged data, so it needs display fields
       the real cart would return on its own. */
    if (!SAME_ORIGIN) {
      var variantTitle = { '1pack': '1 Kit',
                           '2pack': '3 Kits' }[sel.dataset.tier];
      item.title = 'Paid In Full High Gloss Intense Repair Treatment';
      item.variant_title = variantTitle;
      item.price = Math.round(parseFloat(sel.dataset.price.replace(/[^0-9.]/g, '')) * 100);
      item.selling_plan_name = isSub
        ? 'Delivery every ' + currentInterval() + ' days' : null;
      item.image = carouselImages.length
        ? (carouselImages.filter(function (s) {
            return s.indexOf(TIER_IMAGE[sel.dataset.tier]) !== -1;
          })[0] || carouselImages[0])
        : '';
    }

    Cart.add(item)
      .then(function (state) {
        renderCart(state);
        openDrawer();
      })
      .catch(function (e) {
        setError(e.message || 'Could not add to cart. Please try again.');
        openDrawer();
      })
      .then(function () { btn.removeAttribute('aria-busy'); });
  }

  /* ── WIRING ───────────────────────────────────── */
  /* On the theme the CTA is a real <form> posting to /cart/add, so JS-off
     visitors can still buy the selected pack one-time. Intercept the submit
     rather than the click so that fallback stays intact. */
  var atcForm = document.getElementById('pif-form');
  var atcBtn  = document.getElementById('atc-btn');
  if (atcForm) {
    atcForm.addEventListener('submit', function (e) { e.preventDefault(); addToCart(); });
  } else if (atcBtn) {
    atcBtn.addEventListener('click', addToCart);
  }

  document.getElementById('cart-btn').addEventListener('click', function () {
    refreshCart().then(openDrawer);
  });
  document.getElementById('cart-close').addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });

  document.getElementById('cart-checkout').addEventListener('click', function () {
    var url = Cart.checkoutUrl(false);
    if (url) window.location.href = url;
  });

  loadProduct().then(function (data) {
    if (data) buildCarousel(data);
    refreshCart();
  });

  /* ── STICKY BUY BAR (mobile) ──────────────────────
     Visible only between the hero and the offer, and hidden again over the
     final CTA. IntersectionObserver rather than a scroll listener: no work on
     the main thread between the four boundary crossings. */
  (function () {
    var bar = document.getElementById('buy-bar');
    if (!bar || !('IntersectionObserver' in window)) return;

    var hero  = document.querySelector('.hero');
    var zones = [].slice.call(document.querySelectorAll('#offer, .final-cta'));
    if (!hero) return;

    var heroVisible = true;
    var inZone      = {};

    function update() {
      var suppressed = Object.keys(inZone).some(function (k) { return inZone[k]; });
      bar.classList.toggle('is-visible', !heroVisible && !suppressed);
    }

    new IntersectionObserver(function (entries) {
      heroVisible = entries[0].isIntersecting;
      update();
    }, { threshold: 0 }).observe(hero);

    var zoneObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        inZone[zones.indexOf(e.target)] = e.isIntersecting;
      });
      update();
    }, { threshold: 0 });
    zones.forEach(function (z) { zoneObserver.observe(z); });
  })();

  /* ── LIVE RATING + REVIEW COUNT (Yotpo) ───────── */
  /* Platform confirmed as Yotpo from the live PDP. App key is the public
     widgets-repository key exposed in IGK's own page source; this is the
     read-only public widget endpoint, no auth. Product id is the Shopify id.
     Values in the markup are fallbacks only — they match the live PDP at the
     time of writing (4.6 / 372, with the matching star spread) and are
     replaced on load.
     NOTE FOR SHOPIFY BUILD: prefer rendering these server-side in Liquid so
     the numbers are in the HTML on first paint rather than after a fetch. */
  (function () {
    var YOTPO_KEY  = 'ByfcKEsDkcipeCfgscz7HXwKu8n05uSqlhcDmhBE';
    var PRODUCT_ID = '8208481648684';

    fetch('https://api-cdn.yotpo.com/v1/widget/' + YOTPO_KEY +
          '/products/' + PRODUCT_ID + '/reviews.json?per_page=1')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var b = d && d.response && d.response.bottomline;
        if (!b) return;

        if (typeof b.average_score === 'number' && b.average_score > 0) {
          var score = b.average_score.toFixed(1);
          ['hero-rating', 'proof-rating'].forEach(function (id) {
            var el = document.getElementById(id);
            if (el) el.textContent = score;
          });
          paintStars(score);
        }
        if (typeof b.total_review === 'number' && b.total_review > 0) {
          var count = b.total_review.toLocaleString();
          ['hero-count', 'proof-count'].forEach(function (id) {
            var el = document.getElementById(id);
            if (el) el.textContent = count;
          });
          paintDistribution(b.star_distribution, b.total_review);
        }
      })
      .catch(function (e) {
        console.warn('[IGK LP] Yotpo fetch failed — showing fallback rating.', e);
      });
  })();

})();
